module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDUxMiA1MTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01MTIgMjQzLjgxSDI2OC4xOVYwSDI0My44MVYyNDMuODFIMFYyNjguMTlIMjQzLjgxVjUxMkgyNjguMTlWMjY4LjE5SDUxMlYyNDMuODFaIiBmaWxsPSIjNDM2QzdFIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./images/plus-teal.svg
// module id = 50
// module chunks = 0